//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapGetters } from 'vuex';
import BtnFocus from '@/components/subject/btn-focus.vue';
import * as types from '~/types';
export default {
  components: {
    BtnFocus,
  },
  props: ['allThemeData'],
  computed: {
    ...mapGetters('user', ['isLogin', 'userId']),
  },
  watch: {
    isLogin() {
      this.$emit('moreAllTheme');
    },
  },
  methods: {
    moreAllTheme() {
      this.$emit('moreAllTheme');
    },
    ...mapMutations('user', [types.SHOW_LOGIN_FORM]),
  },
};
